import { render, staticRenderFns } from "./AudioPreview.vue?vue&type=template&id=6a0b08f6&scoped=true&"
import script from "./AudioPreview.vue?vue&type=script&lang=js&"
export * from "./AudioPreview.vue?vue&type=script&lang=js&"
import style0 from "./AudioPreview.vue?vue&type=style&index=0&id=6a0b08f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b08f6",
  null
  
)

export default component.exports